import React from 'react'
import { Icon } from '@chakra-ui/react'

export function IconHowToRank({ strokeWidth = 2, ...rest }) {
  return (
    <Icon viewBox="0 0 24 24" {...rest}>
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
        d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"
      />
    </Icon>
  )
}
